import { useMemo } from "react";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { OnEdit } from "components/EditableTable/EditableTable";

export function useAddActionButtonDelete<T extends { id: string }>(
	rows: T[],
	onEdit: OnEdit<T>,
	isReadOnly: (arg: T) => boolean = () => false
) {
	return useMemo(
		() =>
			rows.map(data => ({
				key: data.id,
				data,
				actionWhenEditing: {
					icon: faTrash,
					label: "Delete",
					onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
						e.preventDefault();
						onEdit([{ old: data }]);
					}
				},
				isReadOnly: isReadOnly(data)
			})),
		[rows, onEdit, isReadOnly]
	);
}
